// extracted by mini-css-extract-plugin
export default {"title":"AddAccessoryForm_title__XW5++","description":"AddAccessoryForm_description__WIulQ","notice":"AddAccessoryForm_notice__c5sIY","actions":"AddAccessoryForm_actions__-v3Bj"};